import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
import BillingService from '@/components/Billing/billing-service';
import { FeatureTypes, UpgradePlanDialogProps } from '@/components/Billing/billing-types';
import { capitalizeWord } from '@/utils/language-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradeRequiredIndicator',
  props: {
    iconOnly: { type: Boolean },
    canBuild: { type: Boolean },
    billingFeatureId: null
  },
  setup(__props: any) {

const props = __props as {
	iconOnly?: boolean;
	canBuild?: boolean;
	billingFeatureId: FeatureTypes;
}

const { canEditBilling, usePlanById, useUpNextRequiredPlanToUseData, useUpNextRequiredPlanToUse } = useBilling();
const upNextRequiredPlanToUse = useUpNextRequiredPlanToUse();
const upNextRequiredPlanToUseData = useUpNextRequiredPlanToUseData();
const planById = usePlanById();



const minimalPlanIdToUse = computed(() => upNextRequiredPlanToUse.value(props.billingFeatureId));
const minimalPlanToUse = computed(() => planById.value(minimalPlanIdToUse.value));
const minimalPlanNameToUse = computed(() =>
	minimalPlanToUse.value ? capitalizeWord(BillingService.getPlanGroup(minimalPlanToUse.value)) : ''
);
const openUpgrade = (e?: Event, billingFeatureId?: FeatureTypes) => {
	// billingFeatureId is sometimes passed from a parent component
	e?.preventDefault();
	e?.stopPropagation();
	const featureId = billingFeatureId || props.billingFeatureId;
	const nextPlan = upNextRequiredPlanToUseData.value(featureId);
	const upgradePlanDialogProps: UpgradePlanDialogProps = {
		featureId,
		planId: nextPlan.plan_id,
		productId: nextPlan.product_id,
		canEditBilling: canEditBilling.value,
	};
	BillingService.openUpgradePlanDialog(upgradePlanDialogProps);
};

return { __sfc: true,canEditBilling, usePlanById, useUpNextRequiredPlanToUseData, useUpNextRequiredPlanToUse, upNextRequiredPlanToUse, upNextRequiredPlanToUseData, planById, props, minimalPlanIdToUse, minimalPlanToUse, minimalPlanNameToUse, openUpgrade }
}

})